import { render, staticRenderFns } from "./edmodal.vue?vue&type=template&id=dd3a189c&scoped=true"
import script from "./edmodal.vue?vue&type=script&lang=ts"
export * from "./edmodal.vue?vue&type=script&lang=ts"
import style0 from "./edmodal.vue?vue&type=style&index=0&id=dd3a189c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3a189c",
  null
  
)

export default component.exports